import React from "react";
import { Link } from "react-router-dom";

export const LogoMark = ({ size = 28 }) => (
  <span
    className="inline-flex items-center justify-center rounded-lg bg-slate-900 text-white font-display font-extrabold shadow-[0_4px_14px_rgba(14,165,233,0.35)]"
    style={{ width: size, height: size, fontSize: size * 0.55 }}
  >
    i
  </span>
);

export const Logo = ({ to = "/", testid = "brand-logo" }) => (
  <Link to={to} className="flex items-center gap-2.5 group" data-testid={testid}>
    <LogoMark />
    <span className="font-display font-bold text-[19px] tracking-tight text-slate-900 group-hover:text-sky-600 transition-colors">
      Ishukart
    </span>
  </Link>
);
